export const enum TSEntryStatus {
  NOT_VERIFIED,
  APPROVED,
  REJECTED
}
